import HomeServices from '../services/home-services';
import useBrowserMode from '../shared/hooks/useBrowserMode';
import Cookies from 'universal-cookie';
import CryptoJS from 'crypto-js';
import { normalizeWords } from '../utils/normalizeWords';

const UseTraceItemShipping = (
    userName,
    documentId,
    typeId,
    email,
    eventType,
    eventName,
    jwt
) => {
    const { localStorage } = useBrowserMode();
    const cookies = new Cookies();
    const config = {
        headers: {
            Authorization: jwt,
        },
    };
    const dat =
        cookies.get('CURRENT_BUSINESS') &&
        cookies.get('CURRENT_BUSINESS').toString();
    const decryptionObj = dat && CryptoJS.AES.decrypt(dat, 'comfama');
    const decryptedData =
        decryptionObj !== null && decryptionObj !== undefined
            ? JSON.parse(decryptionObj.toString(CryptoJS.enc.Utf8))
            : null;
    const payload = {
        businessName: localStorage?.getItem('CURRENT_TAB')
            ? localStorage?.getItem('CURRENT_TAB') === 'empresas' &&
              decryptedData !== null
                ? decryptedData?.label
                : null
            : null,
        userName,
        documentId,
        email,
        eventName: eventName
            .split('::')
            [eventName.split('::').length - 1].replace(' ', ''),
        eventType,
        profile: localStorage?.getItem('CURRENT_TAB')
            ? normalizeWords(localStorage?.getItem('CURRENT_TAB'))
            : 'personas',
        transaction: eventName,
        typeId,
        businessDocumentId: localStorage?.getItem('CURRENT_TAB')
            ? localStorage?.getItem('CURRENT_TAB') === 'empresas' &&
              decryptedData
                ? decryptedData?.companyDocID
                : null
            : null,
        businessTypeId: localStorage?.getItem('CURRENT_TAB')
            ? localStorage?.getItem('CURRENT_TAB') === 'empresas' &&
              decryptedData
                ? decryptedData?.companyDocType
                : null
            : null,
        urlOrigin: window?.location?.pathname,
    };

    HomeServices.sendTraceItem(payload, config).catch((e) => console.log(e));
};

export default UseTraceItemShipping;
